import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';

import { ShowingDto } from '@cineamo/api/models/showing/ShowingDto.types';

import { ShowingTagListResponse } from '@cineamo/api/types/ApiListResponse.types';
import { ApiResponse } from '@cineamo/api/types/ApiResponse.types';

import { CACHE_24H, CACHE_30M } from '@cineamo/api/constants/caching-constants';

import { showingKeys } from '@cineamo/api/keys/query-keys';
import { getShowingTags } from '@cineamo/api/resources/showing/showing-api';

export type UseShowingTagsParams = {
    showingId: ShowingDto['id'] | string | undefined;
    enabled?: boolean;
};

// CIN-11360: reusable query definition (usable with useQuery, prefetchQuery, SSR prefetch, …).
export function showingTagsQueryOptions(params: UseShowingTagsParams) {
    const { showingId, enabled = true } = params;

    return queryOptions({
        queryKey: showingKeys.tags(showingId ?? 'disabled'),
        queryFn: () => getShowingTags(showingId!),
        enabled: enabled && !!showingId,
        staleTime: CACHE_30M,
        gcTime: CACHE_24H,
        refetchOnWindowFocus: false
    });
}

export function useShowingTags(
    params: UseShowingTagsParams
): UseQueryResult<ApiResponse<ShowingTagListResponse> | null> {
    return useQuery(showingTagsQueryOptions(params));
}
